import { ExternalProvider } from "../enums/external-provider.enum";
import { LanguageTranslationMap } from "../types/language-translation-map.type";

export const languageTranslatorNames: LanguageTranslationMap<string> = {
    [ExternalProvider.Microsoft]: 'Microsoft Translator',
    [ExternalProvider.IBM]: 'IBM Language Translator',
    [ExternalProvider.Google]: 'Google Translate',
    [ExternalProvider.Amazon]: 'Amazon Translate'
}